import { 
    SET_HREF_DATA,
    LOAD_PATH_SCHEME,
    SET_ACTIVE_TAB,
    NavigationAction,
    NavigationPaths
} from "./types";

export function loadPathScheme(scheme: NavigationPaths): NavigationAction
{
    return {
        type: LOAD_PATH_SCHEME,
        scheme: scheme
    }
}

export function setHrefData(location: Location): NavigationAction
{
    return {
        type: SET_HREF_DATA,
        data: location
    }
}

export function setActiveTab(pageId: string, tabId: string): NavigationAction
{
    return {
        type: SET_ACTIVE_TAB,
        pageId: pageId,
        tabId: tabId
    }
}